import { render, staticRenderFns } from "./show-coord.vue?vue&type=template&id=b3456e42&"
import script from "./show-coord.vue?vue&type=script&lang=js&"
export * from "./show-coord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports